import { ExplorerItemsStorage } from "@/data/explorer.items.storage";
import { episode_001 } from "./episode.001";
//import { episode_002 } from "./episode.002";
//import { episode_003 } from "./episode.003";

export const explorerItemsList = ExplorerItemsStorage.getInstance();

explorerItemsList.addItems(...episode_001);
//explorerItemsList.addItems(...episode_002, ...episode_003);
